<template>
    <div class="storeincome-wrap">
        <el-tabs v-model="activeName">
            <el-tab-pane label="代理信息" name="first">
                <dailiInfo :dailiInfo="accountInfo"/>
            </el-tab-pane>
            <el-tab-pane label="提现记录" name="second">
                <withdrawalRecord/>
            </el-tab-pane>
            <el-tab-pane label="钱包明细" name="third">
                <walletDetails/>
            </el-tab-pane>
            <el-tab-pane label="提现账号" name="forth">
                <Account :dailiInfo="accountInfo"/>
            </el-tab-pane>
        </el-tabs>
       
    </div>
</template>

<script>
import ChannelApi from '@/api/channel.js';
import dailiInfo from "./daili/dailiInfo";
import Account from "./daili/account";
import withdrawalRecord from "./daili/withdrawalRecord";
import walletDetails from "./daili/walletDetails";
export default {
    components:{
        dailiInfo,
        Account,
        withdrawalRecord,
        walletDetails
    },
    data(){
        return{
            activeName:'first',
           accountInfo:{}
        }
    },
    created(){
        this.getUserList()
    },
    methods:{
        getUserList(){
            ChannelApi.channel({}, true).then(res=>{
                const {data} = res.data.list
                this.accountInfo = data[0]
            })
        },
    }

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/channel/user/channel.vue